<script>
    import Profile from './Profile.svelte';
    import Groceries from './Groceries.svelte';
    import Footer from './Footer.svelte';

    import { auth, googleProvider } from './firebase';
    import { signInWithPopup } from 'firebase/auth'
    import { authState } from 'rxfire/auth';

    let user;
    authState(auth).subscribe(u => user = u);

    function login() {
        signInWithPopup(auth, googleProvider)
        // auth.signInWithPopup(googleProvider);
    }
</script>

<style>
    .login {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: grid;
        align-items: center;
        justify-items: center;
        background: #232323;
    }
    button {
        padding: 15px 30px;
        font-size: 20px;
        background: rgba(99, 46, 29, .5);
        border-radius: 30px;
        font-weight: 100;
        color: #fd754a;
    }
</style>
{#if user}
    <Profile {...user} />
    <Groceries uid={user.uid} />
    <Footer />
{:else}
    <div class="login">
        <img src="/images/web-todo-logo.png" width="150" alt="Groceries Shopping List Logo"/>
        <button on:click={login}>
            Login mit Google
        </button>
    </div>
{/if}